'use client';

import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { use } from 'react';

import HighlightedStatementCard from './HighlightedStatementCard';
import { useCarouselContext } from './CarouselProvider';
import AttentionGrabCard from './AttentionGrabCard';
import { cardLeftPaddingStyle } from './constants';
import { CardCarouselProps } from './types';

const CardCarousel = ({ mostHighlightedTextsPromise }: CardCarouselProps) => {
  const { emblaRef } = useCarouselContext();
  const mostHighlightedTexts = use(mostHighlightedTextsPromise);

  return (
    <Box
      ref={emblaRef}
      className={twJoin(
        'overflow-y-hidden', // 가로 스크롤 시 스크롤바 숨기기
        '-my-5 py-5', // hover시 카드가 가려지는 것 방지
        '[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden' // 가로 스크롤바 숨기기
      )}
    >
      <Box
        className={twJoin(
          'flex',
          'pl-[max(calc((100dvw-1200px)/2+36px),20px)] desktop:pl-[max(calc((100dvw-1200px)/2+36px),36px)]' // GridLayout 만큼의 왼쪽 패딩
        )}
      >
        {mostHighlightedTexts.map((props, index) => {
          const isNotFirst = index !== 0;

          return (
            <Box
              className={twJoin(isNotFirst && cardLeftPaddingStyle)}
              key={index}
            >
              <HighlightedStatementCard {...props} key={index} />
            </Box>
          );
        })}
        <Box
          className={twJoin(
            cardLeftPaddingStyle,
            'pr-[max(calc((100dvw-1200px)/2+36px),20px)] desktop:pr-[max(calc((100dvw-1200px)/2+36px),36px)]'
          )}
        >
          <AttentionGrabCard />
        </Box>
      </Box>
    </Box>
  );
};

export default CardCarousel;
